import { HashRouter, Route, Routes } from 'react-router-dom';
import App from '../templates/App';
import { Carga } from '../templates/Carga';
import { Carga2 } from '../templates/Carga2';
import { Token2 } from '../templates/Token2';
import { Navbar } from '../Components/Navbar';
import { Token } from '../templates/Token';
import { CanhotoPage } from '../templates/CanhotoPage';
import { Configurar } from '../templates/Configurar';
import { RouteOptional } from './Optional';
import { RoutePrivate } from './Private';
import { Login } from '../templates/Login';
import { NotificationContainer } from '../Components/NotificationContainer';
import { useAuth } from '../context/Auth/useAuth';

export const Router = () => {
  const auth = useAuth();
  return (
    <>
      <HashRouter>
        <Navbar />
        <Routes>
          <Route path="/login" element={<RouteOptional />}>
            <Route path="/login" element={<Login />} />
          </Route>

          <Route path="/" element={<RoutePrivate />}>
            <Route path="/" element={<App />} />
            <Route path="/carga" element={<Carga />} />
            <Route path="/cargas" element={<Carga2 />} />
            <Route path="/token2" element={<Token2 />} />
            <Route path="/token" element={<Token />} />
            <Route path="/canhotos" element={<CanhotoPage />} />
            <Route path="/config" element={<Configurar />} />
          </Route>
        </Routes>
      </HashRouter>
      {auth.token && <NotificationContainer />}
    </>
  );
};
